import { useState, useEffect, useImperativeHandle, forwardRef, useRef, Fragment } from 'react';
import axios from 'axios';
import { API_ADR, dBConn, SpinnerCentered } from '../../ApiCenter/API_GET';
import { ColorPickerComponent } from "@syncfusion/ej2-react-inputs";
import { DatePickerComponent} from '@syncfusion/ej2-react-calendars';
import dayjs from 'dayjs';
import { ToastContainer, toast } from 'react-toastify';
import Protected from '../../Protected';
import { ButtonFilter } from '../../Components/ButtonFilter';



export const ProjectInfoEdit = forwardRef((props, ref) => {

    const defaultSettings = {
        showModal: false,
        isLoading: true,
        disabled: false,
    }
    const [modalSettings, setModalSettings] = useState(defaultSettings)
    const [dataInfoPanel, setDataInfoPanel] = useState({})
    const originalData = useRef(null);

    useEffect(() => {

        async function fetchData() {
            const result = await axios.get(API_ADR(`editInfo-${modalSettings.type}=${modalSettings.idElement}`));
            if(modalSettings.type === 'project') {
                const bpsProjectCode = result.data?.info?.bps_code;
                let bpsProjectId = result.data?.info?.bps_project_id;       
                if(bpsProjectId === 0 && bpsProjectCode?.length > 0 && bpsProjectCode !== "(Not in BPS)") {
                    bpsProjectId = 1;
                    result.data.info.bps_project_id = 1;
                }
            }
            originalData.current = structuredClone(result.data);
            setDataInfoPanel(result.data)  
            setModalSettings(previous => ({
                ...previous,
                isLoading: false,
                showModal: true,
            }));

        }
        if(modalSettings.type !== undefined && modalSettings.showModal === false){
            fetchData()
        }

    }, [modalSettings])

    useImperativeHandle(ref, () => ({
        openInfoModal(props) {
            setModalSettings(previous => ({
                ...previous,
                type: props.lineContent,
                idElement: props.idElement,
                project_name: props.project_name,
            }))
        }
    }));

    const closePanel = (reloadOrNot) => {
        setModalSettings(defaultSettings)
       props.close()
    }

    async function storeInfo(data){

        data.allScripts?.forEach((l, idx) => {
            l.recalculate = l.adapt_tc_loose !== originalData.current?.allScripts[idx]?.adapt_tc_loose;  
        }) 

        const headers = {
            'Content-Type': 'text/plain'
        };

        // eslint-disable-next-line
        await axios.post(
            API_ADR(`editInfo-${modalSettings.type}-savedata`),
            data,
            {headers}
        ).then(function (result) {

            props.close('reload')

            setTimeout(() => {
            setModalSettings(defaultSettings)
            }, 500)

        })
        .catch(function (error) {
            
        });
    }

    if(modalSettings.type !== undefined &&modalSettings.isLoading){
        return <SpinnerCentered />
    }


    return modalSettings.showModal && (
    <div className="modal fade show" id="AudioMateMenu" tabIndex="-1" aria-modal="true">
        <div className="modal-dialog modal-lg">
            <div className="modal-content" id="AudioMateWindowMenu">
                <div className="modal-header" style={{padding: '7px 10px 5px 16px'}}>
                    <h5 className="modal-title">
                        {modalSettings.type === 'project' &&
                            <span className="iconprbchscrp badge bg-primary" style={{padding: '7px 8px 4px 9px', marginRight: '7px', marginTop: '6px'}}>P</span>
                        }
                        {modalSettings.type === 'batch' &&
                            <span className="iconprbchscrp badge bg-success" style={{padding: '7px 8px 4px 9px', marginRight: '7px', marginTop: '6px'}}>B</span>
                        }
                        {modalSettings.type === 'script' &&
                            <span className="iconprbchscrp badge bg-danger" style={{padding: '7px 8px 4px 9px', marginRight: '7px', marginTop: '6px'}}>S</span>
                        }
                            
                        <span>{modalSettings.project_name}</span>

                    </h5>
                    <button type="button" className="btn" data-bs-dismiss="modal" aria-label="Close" onClick={() => closePanel('')}>🗙</button>    
                </div>
                
                {modalSettings.type === 'project' && <ProjectForm data={dataInfoPanel} onClosePanel={closePanel} sendDataParent={storeInfo} />}
                {modalSettings.type === 'batch' && <BatchForm data={dataInfoPanel} onClosePanel={closePanel} sendDataParent={storeInfo} />}
                {modalSettings.type === 'script' && <ScriptForm  data={dataInfoPanel}  onClosePanel={closePanel} sendDataParent={storeInfo} />}

            </div>
        </div>
    </div>)
})

const ProjectForm = (props) => {

    const formRef = useRef(null);
    const [dataInfoPanel, setDataInfoPanel] = useState()
    const [bpsCodes, setBpsCodes] = useState([]);
    const selectedClientId = useRef(-1);
    const originalBPSCode = useRef(null);
    const [loadingBPS, setLoadingBPS] = useState(false);
    const [waitingResponse, setWaitingResponse] = useState(false);
    const [newMasterProject, setNewMasterProject] = useState(false);
    const [newMasterProjectName, setNewMasterProjectName] = useState("");   
    const [deleteConfim, setDeleteConfim] = useState(''); 
    const [displayAlert, setDisplayAlert] = useState(false);

    useEffect(() => {
        const clientId = parseInt(dataInfoPanel?.info?.client_id ?? -1);
        if(clientId === selectedClientId.current) return;

        selectedClientId.current = clientId;

        const data = [{projectId: 0, code: "(Not in BPS)", name: "", nameCode: ""}];
        const bpsClientId = dataInfoPanel.info?.bps_client_id ?? 0; 
        const bpsProjectId = originalBPSCode.current.bps_project_id ?? 0; 
        const bpsProjectCode = originalBPSCode.current.bps_project_code ?? ""; 
        const addCurrent = parseInt(originalBPSCode.current.client_id) === clientId && bpsProjectId > 0;
        const currentValues = addCurrent ? {projectId: bpsProjectId, code: bpsProjectCode, name: "", nameCode: ""} : null;

        if(parseInt(bpsClientId) === 0) {
            if(currentValues) data.push(currentValues);  
            setBpsCodes(data);
            return;  
        }
        setLoadingBPS(true);
        dBConn.get(`bps-get-projects=&client_id=${bpsClientId}`).then(response => {
            if(!response?.success) {
                if(currentValues) data.push(currentValues);  
            } else {
                const projectsData = response?.data ?? [];
                if(currentValues) {
                    const projectFound = projectsData.find(
                        p => p.projectId === currentValues.projectId || 
                        [p.code, p.name, p.nameCode].filter(v => v != null && v !== "").join(" - ").toLowerCase() === currentValues.code.toLowerCase()
                    );

                    
                    if(Object.keys(projectFound ?? {})?.length > 0) {
                        if(dataInfoPanel.info.bps_project_id !== projectFound.projectId) {
                            setDataInfoPanel(p => { 
                                p.info.bps_project_id = projectFound.projectId;
                                p.info.allow_tts = projectFound.allow_tts;
                                return {...p};
                            })
                        };  
                    } else {
                        data.push(currentValues);
                    }
                }
                if(projectsData.length > 0) data.push(...projectsData);
            };       
            setBpsCodes(data); 
            setLoadingBPS(false);
        })
    }, [dataInfoPanel])

    useEffect(() => {
        if(props.data['info'] !== undefined){
            originalBPSCode.current = {
                client_id: props.data.info.client_id, 
                bps_project_id: props.data.info.bps_project_id,
                bps_project_code: props.data.info.bps_code
            };
            setDataInfoPanel(props.data);
        }
    }, [props])

    const deactivate = (active) => {
        setDeleteConfim('');
        setDataInfoPanel(p => ({
            ...p, info: {...p.info, active: active }
        }));
        if(active === 0) requestAnimationFrame(() => onSubmitHandler(formRef.current));
    }

    const changeStatus = (event, field) => {
        const newValues = {[field]: event.target.value};
        if (field === 'bps_project_id') {
            const p = bpsCodes.find(c => parseInt(c.projectId) === parseInt(event.target.value));
            newValues.bps_project_id = p.projectId;
            newValues['bps_code'] = [p.code, p.name, p.nameCode].filter(v => v != null && v !== "").join(" - ");
        } else if (field === 'client_id') {
            newValues.bps_client_id = dataInfoPanel.clients.find(c => parseInt(c.id) === parseInt(event.target.value))?.bps_id;
            const clientCheck = parseInt(originalBPSCode.current.client_id) === parseInt(event.target.value);
            newValues.bps_project_id = clientCheck ? originalBPSCode.current.bps_project_id : 0;
            newValues.bps_code = clientCheck ? originalBPSCode.current.bps_project_code : "(Not in BPS)";

            const client = dataInfoPanel.clients.find(c => parseInt(c.id) === parseInt(event.target.value));
            if(client.allow_tts === "0"){
                newValues.allow_tts = 0;
            }



        } else if (field === "master_project_id" && event.target.value === '0') {
            setNewMasterProjectName(dataInfoPanel.info.project_name);
            setNewMasterProject(true);
            return;
        }
        setDataInfoPanel(previous => ({
            ...previous,
            info: {
                ...previous.info,
                ...newValues
            }
        }))

    }

    const changeColor = (event, field) => {
        setDataInfoPanel(previous => ({
            ...previous,
            info: {
                ...previous.info,
                [field]: event.value.toUpperCase().slice(0, -2)
            }
        }))
    }

    const onNewProjectNameChange = (e) => {
        setNewMasterProjectName(e.target.value); 
    }

    const createNewMasterProject = () => {
        const mProject = dataInfoPanel.masterProjects.find(
            p => p.master_project_name.trim().toLowerCase() === newMasterProjectName.trim().toLowerCase()
        );
        if(mProject) {
            const newValues = {master_project_id: mProject.id};
            setDataInfoPanel(previous => ({
                ...previous,
                info: {
                    ...previous.info,
                    ...newValues
                }
            }));
            setNewMasterProject(false);
            return;
        }
        setWaitingResponse(true);
        dBConn.post('create-new-master-project', {masterProjectName: newMasterProjectName.trim()})
        .then(response => {
            if(!response?.success) {
                //console.log(response?.message ?? 'error');
            } else {
                const newId = response.id;
                const masterProjects = [...dataInfoPanel.masterProjects];
                masterProjects.push({id: newId.toString(), master_project_name: newMasterProjectName.trim()})
                setDataInfoPanel(previous => ({
                    ...previous,
                    masterProjects: [...masterProjects],
                    info: {
                        ...previous.info,
                        ...{master_project_id: newId}
                    }
                }));
            }
            setWaitingResponse(false);
            setNewMasterProject(false);
        });
    }

    useEffect(() => {
        if(!newMasterProject) setNewMasterProjectName("");
    }, [newMasterProject])

    async function onSubmitHandler(e){
        e.preventDefault()

        if(dataInfoPanel.info.active === 0) {
            if(deleteConfim !== 'delete') {
                setDisplayAlert(true);
                return;
            } else {
                setDeleteConfim('');
                setDisplayAlert(false);
            }
        }

        let checkPreviousOpenScript = parseInt(dataInfoPanel.info.status_batch)

        if(checkPreviousOpenScript < 1 && dataInfoPanel.info.closed === '1'){
            setDataInfoPanel(previous => ({
                ...previous,
                warning: true
            }))
            setNewMasterProject(false);
            return
        }
       
        setDataInfoPanel(previous => ({
            ...previous,
            disabled: true
        }))

        props.sendDataParent(dataInfoPanel.info)
    }

    const removeAlert = () => {
        setDataInfoPanel(previous => ({
            ...previous,
            warning: false
        }))
    }

    const changeSwitch = (event, field) => {
        setDataInfoPanel(previous => ({
            ...previous,
            info: {
                ...previous.info,
                [field]: event.target.checked ? 1 : 0
            }
        }))
    }

    /* continue and force close all scripts */
    const forceClose = () => {
        setDataInfoPanel(previous => ({
            info: {
                ...previous.info,

                forceclose: true,
                disabled: true
            },
            ...previous,
            warning: false
        }))
        dataInfoPanel.info.forceclose = true
        props.sendDataParent(dataInfoPanel.info)
    }

    let divAlertStyle = {position: 'absolute', width: '100%', height: '488px', background: '#7f7f7f40', zIndex: '10', borderRadius: '8px', margin: '-78px -4px'};
    
    if(dataInfoPanel !== undefined) {

        const allowTTS = dataInfoPanel?.clients.find(el => el.id === String(dataInfoPanel.info.client_id))?.allow_tts === "1"

        return (
            <>
                <form ref={formRef} onSubmit={(e) => onSubmitHandler(e)}>
                    <div className="modal-body" style={{padding: '7px 12px 0px 4px'}}>
                        {dataInfoPanel.warning && 
                        <div style={divAlertStyle}>
                            <div className="alert alert-danger" role="alert" style={{margin: '136px 10px 0px 10px'}}>
                                <h6 className="alert-heading">Warning!</h6>
                                <p>There are some Batch/(es) of this project which are still open. This operation will close them</p>
                                <hr />
                                <button 
                                    type="button" 
                                    className="btn btn-secondary btn-sm" 
                                    style={{width: '100px', margin: '0px 0px 0px 10px'}}
                                    onClick={removeAlert}
                                >
                                    Abort
                                </button>
                                <button 
                                    type="button" 
                                    className="btn btn-primary btn-sm" 
                                    style={{width: '100px', margin: '0px 0px 0px 10px'}}
                                    onClick={forceClose}
                                >
                                    Continue
                                </button>
                            </div>
                        </div>}
                        <fieldset disabled={dataInfoPanel.info?.active === 0}>
                            <div className="form-floating form-select-sm col-md-12">
                                <input 
                                    id="project_name" 
                                    type="text" 
                                    className="form-control" 
                                    required={true} 
                                    autoComplete="off" 
                                    spellCheck="false"
                                    value={dataInfoPanel.info.project_name}
                                    onChange={(e) => changeStatus(e, 'project_name')}
                                />
                                <label htmlFor="project_name">Project Name</label>
                            </div>
                            <div className="form-floating form-select-sm col-md-12">
                                <input 
                                    id="real_name" 
                                    type="text" 
                                    className="form-control" 
                                    autoComplete="off" 
                                    spellCheck="false"
                                    value={dataInfoPanel.info.real_name}
                                    onChange={(e) => changeStatus(e, 'real_name')}
                                />
                                <label htmlFor="real_name">Real Name</label>
                            </div>
                            <div className="form-floating form-select-sm col-md-12">
                                {!newMasterProject ?
                                    <Fragment>
                                        <select 
                                            id="master_project" 
                                            className={`form-select form-select-sm`}
                                            value={dataInfoPanel.info.master_project_id}
                                            onChange={(e) => changeStatus(e, 'master_project_id')}
                                        >   
                                            <option key="new" value={0}>New master project</option>
                                            {dataInfoPanel.masterProjects.map((c) => 
                                                <option key={c.id} value={c.id}>{c.master_project_name}</option>
                                            )}
                                        </select>
                                        <label htmlFor="master_project">Master Project</label>
                                    </Fragment>
                                :   
                                    <Fragment>
                                        <input 
                                            id="new_master_project" 
                                            type="text" 
                                            className="form-control" 
                                            autoComplete="off" 
                                            spellCheck="false"
                                            style={{paddingRight: '148px'}}
                                            value={newMasterProjectName}
                                            onChange={onNewProjectNameChange}
                                        />
                                        <label htmlFor="new_master_project">Master Project</label>
                                        {waitingResponse ?
                                            <div 
                                                className="agenda-loading-spin" 
                                                style={{height: '2em', width: '2em', borderWidth: '4px', position: 'absolute', top: '18px', right: '30px'}}
                                            />
                                            :
                                            <div style={{display: 'flex', gap: '4px', position: 'absolute', top: '50%', transform: 'translateY(-50%)', right: '10px', height: 'fit-content'}}>
                                                <button key="save" className="btn btn-danger btn-sm" onClick={createNewMasterProject} disabled={newMasterProjectName.trim() === ""}>Accept</button>
                                                <button key="cancel" className="btn btn-secondary btn-sm" onClick={() => setNewMasterProject(false)}>Cancel</button>
                                            </div>
                                        }
                                    </Fragment>
                                }
                            </div>
                            <div className="form-floating form-select-sm col-md-12">
                                <select 
                                    id="bps_code" 
                                    className={`form-select form-select-sm${loadingBPS ? ' select-loading' : ''}`}
                                    value={dataInfoPanel.info.bps_project_id}
                                    onChange={(e) => changeStatus(e, 'bps_project_id')}
                                    disabled={loadingBPS}
                                >   
                                    {!loadingBPS ? bpsCodes.map((c) => 
                                        <option key={c.projectId} value={c.projectId}>{
                                            [c.code, c.name, c.nameCode].filter(v => v != null && v !== "").join(" - ")
                                        }</option>
                                    ) :
                                        <option key="loading" value={0}>Loading data</option>
                                    }
                                </select>
                                <label htmlFor="bps_code">BPS Code</label>
                                {loadingBPS &&
                                    <div 
                                        className="agenda-loading-spin" 
                                        style={{height: '2em', width: '2em', borderWidth: '4px', position: 'absolute', top: '18px', right: '30px'}}
                                    />
                                }
                            </div>
                            <div className="form-floating form-select-sm col-12">
                                <input id="platforms" type="text" className="form-control" autoComplete="off" spellCheck="false"
                                value={dataInfoPanel.info.platforms || ''} onChange={(e) => changeStatus(e, 'platforms')} />
                                <label htmlFor="platforms">Platform(s)</label>
                            </div>
                            <div className="row">
                                <div className="form-floating form-select-sm col-md-6"  style={{left:'13px'}}>
                                    <select  
                                        id="client_name" 
                                        className="form-select form-select-sm"
                                        value={dataInfoPanel.info.client_id}
                                        onChange={(e) => changeStatus(e, 'client_id')}
                                    >
                                        <option value="0">Select</option>
                                        {dataInfoPanel.clients.map((client, index) => {
                                            return <option key={index} value={client.id}>{client.client_name}</option>
                                        })}
                                    </select>
                                    <label htmlFor="client_name">Client Name</label>
                                </div>
                                <div className="form-floating form-select-sm col-md-6">
                                    <select 
                                        id="franchise" 
                                        className="form-select form-select-sm" 
                                        value={dataInfoPanel.info.franchise_id}
                                        onChange={(e) => changeStatus(e, 'franchise_id')}
                                    >
                                        <option value="0">Select</option>
                                        {dataInfoPanel.franchises.map((franchise, index) => {
                                            return <option key={index} value={franchise.id}>{franchise.franchise_name}</option>
                                        })}
                                    </select>
                                    <label htmlFor="franchise">Franchise</label>
                                </div>
                            </div>
                            <div className="row" style={{paddingLeft: '13px'}}>
                                <div className="form-floating form-select-sm col-md-6">
                                    <select 
                                        className="form-select form-select-sm" 
                                        id="status"
                                        value={dataInfoPanel.info.closed}
                                        onChange={(e) => changeStatus(e, 'closed')}
                                    >
                                        <option value="-1" style={{background: '#ffc107'}}>Not in production</option>
                                        <option value="0" style={{background: '#0d6efd', color: '#FFF'}}>In Progress</option>
                                        <option value="1" style={{background: '#198754', color: '#FFF'}}>Closed</option>
                                    </select>
                                    <label htmlFor="status">Status</label>
                                </div>    
                            </div>
                            <div className="row" style={{paddingLeft: '13px'}}>
                                <div className="form-floating form-select-sm col-md-12">
                                    <div style={{border: '1px solid #CCC', borderRadius: '3px', height: '60px', padding: '16px 7px'}}>
                                        <div className="form-check form-switch">
                                            <input 
                                                className="form-check-input" 
                                                type="checkbox" 
                                                id="allowCueMarkers" 
                                                onChange={(e) => changeSwitch(e, 'allow_cue_markers')} 
                                                checked={dataInfoPanel.info.allow_cue_markers}
                                                style={{width: '40px', height: '20px', marginRight: '8px', marginTop: '1px', cursor: 'pointer'}} 
                                            />
                                            <label className="form-check-label" htmlFor="allowCueMarkers">Allow Cue Markers in Audio Player</label>
                                            <input 
                                                className="form-control form-control-sm" 
                                                type="text" 
                                                value={['null', ''].includes(dataInfoPanel.info.default_marker_label) ? '' : dataInfoPanel.info.default_marker_label} 
                                                placeholder="Label" autoComplete="off" spellCheck="false" 
                                                onChange={(e) => changeStatus(e, 'default_marker_label')}
                                                style={{width: '250px', float: 'right', marginTop: '-4px', marginRight: '4px'}}
                                                disabled={!dataInfoPanel.info.allow_cue_markers}
                                            />
                                        </div>
                                    </div> 
                                </div>
                            </div>
                            <div className="row" style={{paddingLeft: '13px'}}>
                                <div className="form-floating form-select-sm col-md-12">
                                    <div style={{border: '1px solid #CCC', borderRadius: '3px', height: '60px', padding: '16px 7px'}}>
                                        <div className="form-check form-switch">
                                            <input 
                                                className="form-check-input" 
                                                type="checkbox" 
                                                id="allowtts" 
                                                onChange={(e) => changeSwitch(e, 'allow_tts')} 
                                                checked={dataInfoPanel.info.allow_tts}
                                                disabled={!allowTTS}
                                                style={{width: '40px', height: '20px', marginRight: '8px', marginTop: '1px', cursor: 'pointer', opacity: allowTTS ? 1 : 0.5}} 
                                            />
                                            <label className="form-check-label" htmlFor="allowtts" style={{opacity: allowTTS ? 1 : 0.5}}>
                                                Allow Text to Speech to generate Target Synthetic Speech audio
                                            </label>
                                        </div>
                                        {!allowTTS && <span style={{position: 'relative', color: 'red', top: '-6px', fontSize: '11px'}}>No approval to use TTS from this client</span>}
                                    </div>
                                    
                                </div>
                            </div>
                        </fieldset>
                    </div>
                    <hr />
                    <div className="text-center" style={{display: 'flex', gap: '8px', justifyContent: 'center'}}>
                        <Protected returnNull={true} permissions={['deleteNode']} >
                            <button 
                                className="btn btn-danger btn-sm mb-3 bi bi-trash" 
                                title='Delete Project'
                                onClick={() => deactivate(0)} 
                                style={{
                                    width: '30px',
                                    height: '30px',
                                    position: 'absolute',
                                    left: '20px',
                                    padding: '2px'
                                }} 
                            />
                        </Protected>
                        <button 
                            type="submit" 
                            className="btn btn-primary btn-sm mb-3" 
                            style={{'width': '100px'}} 
                            disabled={dataInfoPanel.disabled}
                        >
                            Apply
                        </button>
                    </div>
                    <Protected returnNull={true} permissions={['deleteNode']} extraCondition={displayAlert}>
                        <div className='alert-modals'>
                            <div className='alert-modals-content-div'>
                                <div className='alert-modals-content-header'>
                                    <i className='ri-error-warning-line'/>
                                    <span >Delete Project</span>
                                    <button onClick={(e) => {
                                        e.stopPropagation();
                                        deactivate(1);
                                        setDisplayAlert(false);
                                    }}>🗙</button>
                                </div>
                                <div className='alert-modals-content-body'>
                                    <p>{`Are you sure you want to permanently delete the project ${dataInfoPanel.info.project_name}?`}</p>
                                    <p>
                                        {`This action will delete all batch data, including:`}
                                        {<span>• all batches</span>}
                                        {<span>• all scripts</span>}
                                    </p>
                                    <div>Note: this action is not reversible</div>
                                    <label >
                                        Type "delete" to delete the project.
                                        <input 
                                            id="confirmDelete"
                                            type="text" 
                                            className="form-control form-control-sm"
                                            autoComplete="off" 
                                            spellCheck="false"
                                            onChange={(e) => setDeleteConfim(e.target.value)} 
                                            value={deleteConfim}
                                            style={{width: 'auto', height: 'fit-content'}} 
                                            autoFocus
                                        />
                                    </label>
                                </div>
                                <div className='alert-modals-content-footer'>
                                    <button 
                                        type='submit'
                                        className='btn btn-primary btn-sm mb-3' 
                                        disabled={deleteConfim !== 'delete'}
                                    >
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Protected>
                </form>
            </>
        )
    }
}

const BatchForm = (props) => {

    const formRef = useRef(null);
    const dateStart = useRef(null);
    const dateEnd = useRef(null);

    const onFocusStart = (args) => {
        dateStart.show();
    }
    const onFocusEnd = (args) => {
        dateEnd.show();
    }

    const [dataInfoPanel, setDataInfoPanel] = useState();
    const [bpsCodes, setBpsCodes] = useState([]);
    const [loadingBPS, setLoadingBPS] = useState(false);
    const bpsLoaded = useRef(false);
    const [deleteConfim, setDeleteConfim] = useState(''); 
    const [displayAlert, setDisplayAlert] = useState(false);

    useEffect(() => {
        if(props.data['info'] !== undefined){
            setDataInfoPanel({...props.data, warning: false})
        }
    }, [props])

    const changeStatus = (event, field) => {
        const newValues = {[field]: event.target.value};
        if(field === 'bps_transaction_id') {
            const p = bpsCodes.find(c => parseInt(c.serviceRequestId) === parseInt(event.target.value));
            newValues.bps_transaction_id = p.serviceRequestId;
            newValues['bps_transaction_code'] = p.code;
        }

        setDataInfoPanel(previous => ({
            ...previous,
            info: {
                ...previous.info,
                ...newValues
            }
        }))
    }

    const changeFormValuesDatePicker = (event, field) => {
        setDataInfoPanel(previous => ({
            ...previous,
            info: {
                ...previous.info,
                [field]: reFormatDate(event.value)
            }
        }))
    }

    async function onSubmitHandler(e){
        e.preventDefault()

        if(dataInfoPanel.info.active === 0) {
            if(deleteConfim !== 'delete') {
                setDisplayAlert(true);
                return;
            } else {
                setDeleteConfim('');
                setDisplayAlert(false);
            }
        }

        if(dayjs(dataInfoPanel.info.start_date).isAfter(dayjs(dataInfoPanel.info.end_date))){
            toast.error('Check the dates entered. End Date is before Start Date');
            return
        } 


        let checkPreviousOpenScript = parseInt(dataInfoPanel.info.status_script)
        if(dataInfoPanel.info['forceclose'] === undefined){

            if(checkPreviousOpenScript < 1 && dataInfoPanel.info.closed === '1'){
                setDataInfoPanel(previous => ({
                    ...previous,
                    warning: true
                }))
                return
            }
        }

        setDataInfoPanel(previous => ({
            ...previous,
            disabled: true
        }))

        props.sendDataParent(dataInfoPanel.info)
    }


    /* remove window alert */
    const removeAlert = () => {
        setDataInfoPanel(previous => ({
            ...previous,
            warning: false
        }))
    }

    /* continue and force close all scripts */
    const forceClose = () => {
        setDataInfoPanel(previous => ({
            info: {
                ...previous.info,
                forceclose: true,
                disabled: true
            },
            ...previous,
            warning: false
        })) 
        dataInfoPanel.info.forceclose = true
        props.sendDataParent(dataInfoPanel.info)
    }


    const changeSwitch = (event, field) => {
        setDataInfoPanel(previous => ({
            ...previous,
            info: {
                ...previous.info,
                [field]: event.target.checked ? 1 : 0
            }
        }))
    }

    const deactivate = (active) => {
        setDeleteConfim('');
        setDataInfoPanel(p => ({
            ...p, info: {...p.info, active: active }
        }));
        if(active === 0) requestAnimationFrame(() => onSubmitHandler(formRef.current));
    }

    let divAlertStyle = {position: 'absolute', width: '100%', height: '425px', background: '#7f7f7f40', zIndex: '10', borderRadius: '8px', margin: '-78px -4px'};

    useEffect(() => {
        if(!dataInfoPanel || bpsLoaded.current) return;
        bpsLoaded.current = true;

        const bpsProjectId = parseInt(dataInfoPanel.info?.bps_project_id ?? 0);
        const data = [{serviceRequestId: 0, code: "(Not in BPS)", name: "", nameCode: ""}];

        const bpsTransactionCode = dataInfoPanel.info?.bps_transaction_code ?? "";
        let bpsTransactionId = parseInt(dataInfoPanel.info?.bps_transaction_id ?? 0);
        if(bpsTransactionId === 0 && bpsTransactionCode !== "(Not in BPS)" && bpsTransactionCode?.length > 0) bpsTransactionId = 1;
        const currentValues = bpsTransactionId > 0 ? {serviceRequestId: bpsTransactionId, code: bpsTransactionCode, name: "", nameCode: ""} : null;

        if(bpsProjectId === 0) {
            if(currentValues) data.push(currentValues);  
            setBpsCodes(data);
            return;
        }

        setLoadingBPS(true);
        dBConn.get(`bps-get-transactions=&project_id=${bpsProjectId}`).then(response => {
            if(!response?.success) {
                if(currentValues) data.push(currentValues);  
            } else {
                const transactionsData = response?.data ?? [];
                if(currentValues) {
                    const transactionFound = transactionsData.find(
                        p => p.serviceRequestId === currentValues.serviceRequestId || 
                        p.code?.toLowerCase() === currentValues.code?.toLowerCase()
                    );
                    if(Object.keys(transactionFound ?? {})?.length > 0) {
                        if(dataInfoPanel.info.bps_transaction_id !== transactionFound.serviceRequestId) {
                            setDataInfoPanel(p => { 
                                p.info.bps_transaction_id = transactionFound.serviceRequestId;
                                return {...p};
                            })
                        };  
                    } else {
                        data.push(currentValues);
                    }
                }
                if(transactionsData.length > 0) data.push(...transactionsData);
            };       
            setBpsCodes(data); 
            setLoadingBPS(false);
        })
    }, [dataInfoPanel])

    if(!dataInfoPanel || dataInfoPanel.length === 0) return null;

    return (
        <>
            <form ref={formRef} onSubmit={(e) => onSubmitHandler(e)}>
                <div className="modal-body" style={{padding: '7px 12px 0px 4px'}}>
                    {dataInfoPanel.warning && 
                        <div style={divAlertStyle}>
                            <div className="alert alert-danger" role="alert" style={{margin: '95px 10px 0px 10px'}}>
                                <h6 className="alert-heading">Warning!</h6>
                                <p>There are some scripts of this batch which are still open. This operation will close them</p>
                                <hr />

                                <button type="button" className="btn btn-secondary btn-sm" style={{width: '100px', margin: '0px 0px 0px 10px'}}
                                onClick={removeAlert}>Abort</button>
                                <button type="button" className="btn btn-primary btn-sm" style={{width: '100px', margin: '0px 0px 0px 10px'}}
                                onClick={forceClose}>Continue</button>
                            </div>
                        </div>
                    }
                    <fieldset disabled={dataInfoPanel.info?.active === 0}>
                        <div className="form-floating form-select-sm col-12">
                            <ToastContainer />
                            <input id="batch_name" type="text" className="form-control" required={true} autoComplete="off" spellCheck="false"
                            value={dataInfoPanel.info.batch_name} onChange={(e) => changeStatus(e, 'batch_name')} />
                            <label htmlFor="batch_name">Batch Name</label>
                        </div>

                        <div className="form-floating form-select-sm col-md-12">
                            <select 
                                id="bps_code" 
                                className={`form-select form-select-sm${loadingBPS ? ' select-loading' : ''}`}
                                value={dataInfoPanel.info.bps_transaction_id}
                                onChange={(e) => changeStatus(e, 'bps_transaction_id')}
                                disabled={loadingBPS}
                            >
                                {!loadingBPS ? bpsCodes.map((c) => 
                                    <option key={c.serviceRequestId} value={c.serviceRequestId}>{
                                        [c.name, c.code].filter(v => v != null && v !== "").join(" | ")
                                    }</option>
                                ) :
                                    <option key="loading" value={0}>Loading data</option>
                                }
                            </select>
                            <label htmlFor="bps_code">BPS Transaction Code</label>
                            {loadingBPS &&
                                <div 
                                    className="agenda-loading-spin" 
                                    style={{height: '2em', width: '2em', borderWidth: '4px', position: 'absolute', top: '18px', right: '30px'}}
                                />
                            }
                        </div>
                        {/*
                            <div className="form-floating form-select-sm col-md-12">
                                <input id="bps_code" type="text" className="form-control" autoComplete="off" spellCheck="false"
                                    value={dataInfoPanel.info.bps_transaction_code}
                                    onChange={(e) => changeStatus(e, 'bps_transaction_code')}/>
                                <label htmlFor="bps_code">BPS Transaction Code</label>
                            </div>
                        */}

                        <div className="row">
                            <div className="form-floating form-select-sm col-6" style={{left:'13px'}}>
                                <select id="studio_lead" className="form-select form-select-sm" 
                                value={dataInfoPanel.info.lead_studio_id}
                                onChange={(e) => changeStatus(e, 'lead_studio_id')} >
                                    <option value="0">Select</option>
                                    {dataInfoPanel.studios.map((studio, index) => {
                                        return <option key={index} value={studio.id}>{studio.site_code}</option>
                                    })}
                                </select>
                                <label htmlFor="studio_lead">Studio Lead</label>
                            </div>
                            <div className="form-floating form-select-sm col-6">
                                <select id="pm_name" className="form-select form-select-sm"
                                value={dataInfoPanel.info.pm_id}
                                onChange={(e) => changeStatus(e, 'pm_id')} >
                                    <option value="0">Select</option>
                                    {dataInfoPanel.pms.map((pm, index) => {
                                        return parseInt(dataInfoPanel.info.lead_studio_id) === parseInt(pm.site_id) ? <option key={index} value={pm.id}>{pm.pm_name}</option> : null;
                                    })}
                                </select>
                                <label htmlFor="pm_name">PM Name</label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-floating form-select-sm col-6" style={{left:'13px'}}>
                                <select id="studio_lead" className="form-select form-select-sm" 
                                value={dataInfoPanel.info.apl_id ?? 0}
                                onChange={(e) => changeStatus(e, 'apl_id')} >
                                    <option value="0">Select</option>
                                    {dataInfoPanel.apls.map((apl, index) => {
                                        return <option key={index} value={apl.id}>{apl.resource_name}</option>
                                    })}
                                </select>
                                <label htmlFor="studio_lead">APL</label>
                            </div>
                            <div className="form-floating form-select-sm col-6">
                                <select id="pm_name" className="form-select form-select-sm"
                                value={dataInfoPanel.info.qac_id ?? 0}
                                onChange={(e) => changeStatus(e, 'qac_id')} >
                                    <option value="0">Select</option>
                                    {dataInfoPanel.qacs.map((qac, index) => {
                                        return <option key={index} value={qac.id}>{qac.resource_name}</option>
                                    })}
                                </select>
                                <label htmlFor="pm_name">QA Coordinator</label>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6 mt-1" style={{border: '1px solid #CCC', width: '383px', marginLeft: '21px', borderRadius: '3px', left:'13px'}}>
                                <label htmlFor="batch_start">Start Date</label>
                                    <DatePickerComponent id="batch_start" name="booking_date_r"                            
                                        ref={dateStart}
                                        openOnFocus={onFocusStart}
                                        start={onFocusStart}
                                        value={AM_dateTime_ExtractDate(dataInfoPanel.info.start_date)}
                                        change={(e) => changeFormValuesDatePicker(e, 'start_date')}
                                        format='d-MMM-yyyy' 
                                        placeholder='Enter date'
                                />
                            </div>
                            <div className="col-md-6 mt-1" style={{border: '1px solid #CCC', width: '382px', marginLeft: '8px', borderRadius: '3px'}}>
                                <label htmlFor="batch_end">End Date</label>
                                    <DatePickerComponent id="batch_end" name="booking_date_r" 
                                        ref={dateEnd}
                                        openOnFocus={onFocusEnd}
                                        start={onFocusEnd}
                                        value={AM_dateTime_ExtractDate(dataInfoPanel.info.end_date)}
                                        change={(e) => changeFormValuesDatePicker(e, 'end_date')}
                                        format='d-MMM-yyyy' 
                                        placeholder='Enter date'
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-floating form-select-sm col-md-6" style={{left:'13px', marginTop: '4px'}}>
                                <select className="form-select form-select-sm" id="status"
                                    value={dataInfoPanel.info.closed}
                                    onChange={(e) => changeStatus(e, 'closed')}
                                    >
                                        <option value="-1" style={{background: '#ffc107'}}>Not in production</option>
                                        <option value="0" style={{background: '#0d6efd', color: '#FFF'}}>In Progress</option>
                                        <option value="1" style={{background: '#198754', color: '#FFF'}}>Closed</option>
                                </select>
                                <label htmlFor="status">Status</label>
                            </div>
                            <div className="form-floating form-select-sm col-6 mt-1" style={{paddingTop: '1px'}}>
                                <div className="col-md-6 mt-1" 
                                    style={{border: '1px solid #CCC', width: '380px', marginLeft: '2px', borderRadius: '3px', height: '57px', padding: '4px'}}>
                                    <div style={{fontSize: '12px', color: '#888', marginTop: '-3px'}}>Client dashboard (if available)</div>
                                    <div className="form-check form-switch" style={{margin: '3px'}}>
                                        <input className="form-check-input" type="checkbox" id="flexSwitchCheckChecked" 
                                        checked={dataInfoPanel.info.show_in_dashboard === 1 ? true : false} style={{width: '40px', height: '20px'}}
                                        onChange={(e) => changeSwitch(e, 'show_in_dashboard')}/>
                                        <span style={{margin: '0px 10px', paddingTop: '3px', display: 'inline-block'}} className="form-check-label">Show in dashboard</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>
                <hr />
                <div className="text-center" style={{display: 'flex', gap: '8px', justifyContent: 'center'}}>
                    <Protected returnNull={true} permissions={['deleteNode']} >
                        <button 
                            className="btn btn-danger btn-sm mb-3 bi bi-trash" 
                            title='Delete Batch'
                            onClick={() => deactivate(0)} 
                            style={{
                                width: '30px',
                                height: '30px',
                                position: 'absolute',
                                left: '20px',
                                padding: '2px'
                            }} 
                        />
                    </Protected>
                    <button 
                        type="submit" 
                        className="btn btn-primary btn-sm mb-3" 
                        style={{'width': '100px'}} 
                        disabled={dataInfoPanel.disabled}
                    >
                        Apply
                    </button>
                </div>
                <Protected returnNull={true} permissions={['deleteNode']} extraCondition={displayAlert}>
                    <div className='alert-modals'>
                        <div className='alert-modals-content-div'>
                            <div className='alert-modals-content-header'>
                                <i className='ri-error-warning-line'/>
                                <span >Delete Batch</span>
                                <button onClick={(e) => {
                                    e.stopPropagation();
                                    deactivate(1);
                                    setDisplayAlert(false);
                                }}>🗙</button>
                            </div>
                            <div className='alert-modals-content-body'>
                                <p>{`Are you sure you want to permanently delete the batch ${dataInfoPanel.info.batch_name}?`}</p>
                                <p>
                                    {`This action will delete all batch data, including:`}
                                    {<span>• all scripts</span>}
                                </p>
                                <div>Note: this action is not reversible</div>
                                <label >
                                    Type "delete" to delete the batch.
                                    <input 
                                        id="confirmDelete"
                                        type="text" 
                                        className="form-control form-control-sm"
                                        autoComplete="off" 
                                        spellCheck="false"
                                        onChange={(e) => setDeleteConfim(e.target.value)} 
                                        value={deleteConfim}
                                        style={{width: 'auto', height: 'fit-content'}} 
                                        autoFocus
                                    />
                                </label>
                            </div>
                            <div className='alert-modals-content-footer'>
                                <button 
                                    type='submit'
                                    className='btn btn-primary btn-sm mb-3' 
                                    disabled={deleteConfim !== 'delete'}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </Protected>
            </form>
        </>)
}

const ScriptForm = (props) => {

    const formRef = useRef(null);
    const dateStart = useRef(null);
    const dateEnd = useRef(null);
    const [deleteConfim, setDeleteConfim] = useState(''); 
    const [displayAlert, setDisplayAlert] = useState(false);
    const glossaries = useRef([]);
    const currentGlossaries = useRef([]);

    const onFocusStart = (args) => {
        dateStart.show();
    }
    const onFocusEnd = (args) => {
        dateEnd.show();
    }


    const [dataInfoPanel, setDataInfoPanel] = useState()
    const [xlocOptions, setXlocOptions] = useState(false);

    useEffect(() => {
        if(props.data['info'] !== undefined){
            setDataInfoPanel(props.data);
        }
    }, [props])

    const changeStatus = (event, field) => {
        let newVal = event.target.value;
        if(field === 'xloc_tenant') {
            const match = newVal.match(/^https?:\/\/[^/?#]*\.com/);
            if(match) newVal = match[0];
        }
        setDataInfoPanel(previous => ({
            ...previous,
            info: {
                ...previous.info,
                [field]: newVal
            }
        }))
    }

    const changeFormValuesDatePicker = (event, field) => {
 
        setDataInfoPanel(previous => {

            const updatedInfo = {
                ...previous.info,
                [field]: reFormatDate(event.value)
            };
    
            if (field === 'script_start_date' || field === 'script_end_date') {



                const updatedAllScripts = previous.allScripts.map(script => ({
                    ...script,
                    language_start_date: field === 'script_start_date' && new Date(reFormatDate(event.value)) > new Date(script.language_start_date) 
                                        ? reFormatDate(event.value) 
                                        : reFormatDate(script.language_start_date),
                    language_end_date: field === 'script_end_date' && new Date(reFormatDate(event.value)) < new Date(script.language_end_date) 
                                        ? reFormatDate(event.value) 
                                        : reFormatDate(script.language_end_date)


                }));

                return {
                    ...previous,
                    info: updatedInfo,
                    allScripts: updatedAllScripts
                };
            } else {
                return {
                    ...previous,
                    info: updatedInfo
                };
            }
        });
    };

    const updateLanguage = (event, field, index) => {

        setDataInfoPanel(previous => {
            const updatedAllScripts = previous.allScripts.map((script, i) => {
                if (i === index) {
                    return {
                        ...script,
                        changed: true,
                        [field]:    field === 'adapt_tc_loose' ? (script.adapt_tc_loose === 0 ? 1 : 0) :  
                                    field === 'active' ? (script.active === 0 ? 1 : 0) : 
                                    reFormatDate(event.value)
                    };
                } else {
                    return script;
                }
            });

            return {
                ...previous,
                allScripts: updatedAllScripts
            };
        });
    }

    const changeSwitch = (event, field) => {
        const newVal = field === 'xloc_update_audio_filetype_id' ? parseInt(event.target.value) : event.target.checked ? 1 : 0;
        setDataInfoPanel(previous => ({
            ...previous,
            info: {
                ...previous.info,
                [field]: newVal
            }
        }))
    }

    const deactivate = (active) => {
        setDeleteConfim('');
        setDataInfoPanel(p => ({
            ...p, info: {...p.info, active: active }
        }));
        if(active === 0) requestAnimationFrame(() => onSubmitHandler(formRef.current));
    }

    async function onSubmitHandler(e){
        e.preventDefault()
        if((dataInfoPanel.info.active === 0 || dataInfoPanel.allScripts.some(s => s.active === 0))) {
            if(deleteConfim !== 'delete') {
                setDisplayAlert(true);
                return;
            } else {
                setDeleteConfim('');
                setDisplayAlert(false);
            }
        }
        
        let checkErrors = 0;
        if(dayjs(dataInfoPanel.info.script_start_date).isAfter(dayjs(dataInfoPanel.info.script_end_date))){
            checkErrors++;
        }

        if(checkErrors !== 0){
            toast.error('Check the dates entered of the Scripts. End Date is before Start Date');
            return
        }

        const checkLanguagesErrors = [];

        dataInfoPanel.allScripts.forEach(scrpt => {
            if(dayjs(scrpt.language_start_date).isAfter(dayjs(scrpt.language_end_date))){
                checkLanguagesErrors.push(scrpt.language_code)
            }
        })

        if(checkLanguagesErrors.length !== 0){
            toast.error(`Check the dates entered of the Languages (${checkLanguagesErrors.join(', ')}). End Date is before Start Date`);
            return
        }

        setDataInfoPanel(previous => ({
            ...previous,
            disabled: true
        }))

        if(glossaries.current.length > 0) {
            const newGlossaryIds = glossaries.current.filter(g => g.isChecked);
            const defaultGlossary = currentGlossaries.current.filter(g => g.main === 1)?.[0];
            dataInfoPanel.glossaries = [defaultGlossary?.id, ...newGlossaryIds.map(g => g.id)];
        }

        props.sendDataParent(dataInfoPanel);
    }


    if(dataInfoPanel !== undefined){

        const toggleAll = () => {
            if(dataInfoPanel.info.active === 0) return; 
            setDataInfoPanel(p => {
                const newState = p.allScripts.some(l => l.adapt_tc_loose === 0) ? 1 : 0;
                p.allScripts.forEach(l => {
                    l.adapt_tc_loose = newState;
                })
                return {...p}
            })
        }

        const getPronFranchises = (updateData) => {
            if(glossaries.current.length === 0) {
                dBConn('getGlossariesToAssign', {scriptId: dataInfoPanel.info.script_id}).then(r => {
                    currentGlossaries.current = structuredClone(r?.data?.filter(r => r.priority > 0));
                    const data = r?.data.filter(r => {
                        r.isChecked = r.priority > 0;
                        return r.main !== 1;
                    });
                    glossaries.current.push(...(data ?? []));
                    updateData();
                });
            } else {
                updateData();
            }
        }

        return (
            <>
                <form ref={formRef} onSubmit={(e) => onSubmitHandler(e)}>
                    <div className="modal-body" style={{padding: '7px 12px 0px 4px'}}>
                        <fieldset disabled={dataInfoPanel.info?.active === 0}>
                            <div className="form-floating form-select-sm col-12">
                                <input id="script_name" type="text" className="form-control" required={true} autoComplete="off" spellCheck="false"
                                value={dataInfoPanel.info.script_name}
                                onChange={(e) => changeStatus(e, 'script_name')} />
                                <label htmlFor="script_name">Script Name</label>
                            </div>
                            <div className="row">
                                <ToastContainer />
                                <div className="col-md-6 mt-1" style={{border: '1px solid #CCC', width: '383px', marginLeft: '21px', borderRadius: '3px'}}>
                                <div style={{fontSize: '12px', color: '#888', marginLeft: '-7px', marginTop: '2px'}}>Start Date (all script)</div>
                                <DatePickerComponent id="script_start_date"                    
                                                ref={dateStart}
                                                openOnFocus={onFocusStart}
                                                start={onFocusStart}
                                                value={AM_dateTime_ExtractDate(dataInfoPanel.info.script_start_date)}
                                                min={AM_dateTime_ExtractDate(dataInfoPanel.info.batch_start_date)}
                                                max={AM_dateTime_ExtractDate(dataInfoPanel.info.batch_end_date)}
                                                change={(e) => changeFormValuesDatePicker(e, 'script_start_date')}
                                                format='d-MMM-yyyy' 
                                                placeholder='Enter date'
                                />
                            </div>
                                <div className="col-md-6 mt-1" style={{border: '1px solid #CCC', width: '383px', marginLeft: '8px', borderRadius: '3px'}}>
                                    <div style={{fontSize: '12px', color: '#888', marginLeft: '-7px', marginTop: '2px'}}>End Date (all script)</div>
                                    <DatePickerComponent id="script_end_date"
                                                ref={dateEnd}
                                                openOnFocus={onFocusEnd}
                                                start={onFocusEnd}
                                                value={AM_dateTime_ExtractDate(dataInfoPanel.info.script_end_date)}
                                                min={AM_dateTime_ExtractDate(dataInfoPanel.info.batch_start_date)}
                                                max={AM_dateTime_ExtractDate(dataInfoPanel.info.batch_end_date)}
                                                change={(e) => changeFormValuesDatePicker(e, 'script_end_date')}
                                                format='d-MMM-yyyy' 
                                                placeholder='Enter date'
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form-floating form-select-sm col-6 mt-1" style={{left:'13px'}}>
                                    <select className="form-select form-select-sm" id="status"
                                        value={dataInfoPanel.info.script_status_id}
                                        onChange={(e) => changeStatus(e, 'script_status_id')}
                                        >
                                            <option value="-1" style={{background: '#ffc107'}}>Not in production</option>
                                            <option value="0" style={{background: '#0d6efd', color: '#FFF'}}>In Progress</option>
                                            <option value="1" style={{background: '#198754', color: '#FFF'}}>Closed</option>
                                        </select>
                                        <label htmlFor="status">Status</label>
                                </div>
                                <div className="form-floating form-select-sm col-6 mt-1">
                                    <div style={{border: '1px solid #CCC', marginLeft: '2px', borderRadius: '3px', height: '57px', padding: '4px'}}>
                                        <div style={{fontSize: '12px', color: '#888', marginTop: '-3px'}}>Ingame</div>
                                        <div className="form-check form-switch" style={{margin: '3px'}}>
                                            <input className="form-check-input" type="checkbox" id="flexSwitchCheckChecked" 
                                                checked={dataInfoPanel.info.is_game_content === 1 ? true : false} style={{width: '40px', height: '20px'}}
                                                onChange={(e) => changeSwitch(e, 'is_game_content')}/>
                                            <span style={{margin: '0px 10px', paddingTop: '3px', display: 'inline-block'}} className="form-check-label">Is Game Content</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="form-floating form-select-sm col-6 mt-0" style={{left:'13px'}}>
                                    <div style={{border: '1px solid #CCC', marginLeft: '2px', borderRadius: '3px', height: '57px', padding: '4px'}}>
                                        <div style={{fontSize: '12px', color: '#888', marginTop: '-3px'}}>Deactivable Lines</div>
                                        <div className="form-check form-switch" style={{margin: '3px'}}>
                                            <input className="form-check-input" type="checkbox" id="flexSwitchCheckChecked" 
                                                checked={dataInfoPanel.info.deactivable === 1 ? true : false} style={{width: '40px', height: '20px'}}
                                                onChange={(e) => changeSwitch(e, 'deactivable')}/>
                                            <span style={{margin: '0px 10px', paddingTop: '3px', display: 'inline-block'}} className="form-check-label">Script lines deactivable </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-floating form-select-sm col-6 mt-0">
                                    <div style={{border: '1px solid #CCC', marginLeft: '2px', borderRadius: '3px', height: '57px', padding: '4px'}}>
                                        <div style={{fontSize: '12px', color: '#888', marginTop: '-3px'}}>Asrec Confirmation</div>
                                        <div className="form-check form-switch" style={{margin: '3px'}}>
                                            <input className="form-check-input" type="checkbox" id="flexSwitchCheckChecked" 
                                                checked={dataInfoPanel.info.asrec_confirmation === 1 ? true : false} style={{width: '40px', height: '20px'}}
                                                onChange={(e) => changeSwitch(e, 'asrec_confirmation')}/>
                                            <span style={{margin: '0px 10px', paddingTop: '3px', display: 'inline-block'}} className="form-check-label">Asrec confirmation </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="form-floating form-select-sm col-6 mt-1" style={{left:'13px'}}>
                                    <ButtonFilter 
                                        fetchData={getPronFranchises} 
                                        data={glossaries.current} 
                                        displayName='franchise_name'
                                        buttonClass="form-select form-select-sm" 
                                        buttonTitle={"Add additional pronunciations glossaries"}
                                        menuAlign='left'
                                        buttonIcon={false}
                                        buttonText={'Extra Pronunciation Glossaries'}
                                        showIcons={false}
                                        title="Extra Glossaries"
                                        uniqueSelection={false}
                                        allowEmpty={true}
                                        emptyMessage="No glossaries available"
                                        searchOption={true}
                                        searchMode='filter'
                                        showClearFilter={false}
                                        confirmFn={(e) => console.log(e)}
                                    />
                                    <label >Pronunciation Glossaries</label>
                                </div>
                            </div>
                            <Protected returnNull={true} permissions={['xlocModule']}>
                                <div className="row" style={{margin: '4px 0 0 11px', border: '1px solid #CCC', borderRadius: '6px', padding: '0.25em 0.5em', gap: '4px'}}>
                                    <div key="xlocoptions" className="form-floating form-select-sm col-12" style={{padding: '0'}}>
                                        <div className="form-check form-switch">
                                            <label style={{margin: '0px 10px', paddingTop: '3px', display: 'inline-block'}} className="form-check-label">XLOC Options</label>
                                            <input className="form-check-input" type="checkbox" id="flexSwitchCheckChecked" 
                                                checked={xlocOptions ? true : false} style={{width: '40px', height: '20px'}}
                                                onChange={() => setXlocOptions(p => !p)}/>
                                        </div>
                                    </div>
                                    {xlocOptions && 
                                        <Fragment>
                                            <div key="tenant" className="form-floating form-select-sm col-12" style={{padding: '0'}}>
                                                <input type="text" className="form-control" required={true} autoComplete="off" spellCheck="false"
                                                    value={dataInfoPanel.info.xloc_tenant}
                                                    onChange={(e) => changeStatus(e, 'xloc_tenant')} />
                                                <label htmlFor="script_name">XLOC URL (https://domain.cloud.xloc.com)</label>
                                            </div>
                                            <div key="localizationId" className="form-floating form-select-sm col-12" style={{padding: '0'}}>
                                                <input type="text" className="form-control" required={true} autoComplete="off" spellCheck="false"
                                                    value={dataInfoPanel.info.xloc_localization_id}
                                                    onChange={(e) => changeStatus(e, 'xloc_localization_id')} />
                                                <label htmlFor="script_name">Localization ID</label>
                                            </div>
                                            <div key="autoupdate" className="form-floating form-select-sm col-12" 
                                                style={{padding: '0.25em', border: '1px solid #ccc', borderRadius: '7px'}}>
                                                <div className="form-check form-switch" style={{display: 'flex', alignItems: 'center'}}>
                                                    <input className="form-check-input" type="checkbox" id="flexSwitchCheckChecked" 
                                                        checked={dataInfoPanel.info?.xloc_autoupdate === 1 ? true : false} style={{width: '40px', height: '20px'}}
                                                        onChange={(e) => changeSwitch(e, 'xloc_autoupdate')}/>
                                                    <span style={{margin: '0px 10px'}} className="form-check-label">Auto update on script changes </span>
                                                </div>
                                            </div>
                                            <div key="updatetext" className="form-floating form-select-sm col-12" 
                                                style={{padding: '0.25em', border: '1px solid #ccc', borderRadius: '7px'}}>
                                                <div className="form-check form-switch" style={{display: 'flex', alignItems: 'center'}}>
                                                    <input className="form-check-input" type="checkbox" id="flexSwitchCheckChecked" 
                                                        checked={dataInfoPanel.info?.xloc_update_asrec === 1 ? true : false} style={{width: '40px', height: '20px'}}
                                                        onChange={(e) => changeSwitch(e, 'xloc_update_asrec')}/>
                                                    <span style={{margin: '0px 10px'}} className="form-check-label">Update AsRec text</span>
                                                </div>
                                            </div>
                                            <div key="updatestatus" className="form-floating form-select-sm col-12" 
                                                style={{padding: '0.25em', border: '1px solid #ccc', borderRadius: '7px'}}>
                                                <div className="form-check form-switch" style={{display: 'flex', alignItems: 'center'}}>
                                                    <input className="form-check-input" type="checkbox" id="flexSwitchCheckChecked" 
                                                        checked={dataInfoPanel.info?.xloc_update_status === 1 ? true : false} style={{width: '40px', height: '20px'}}
                                                        onChange={(e) => changeSwitch(e, 'xloc_update_status')}/>
                                                    <span style={{margin: '0px 10px'}} className="form-check-label">Update line status</span>
                                                </div>
                                            </div>
                                            <div key="updateaudio" className="form-floating form-select-sm col-12" 
                                                style={{padding: '0.25em', border: '1px solid #ccc', borderRadius: '7px'}}>
                                                <div className="form-check form-switch" style={{display: 'flex', alignItems: 'center'}}>
                                                    <input className="form-check-input" type="checkbox" id="flexSwitchCheckChecked" 
                                                        checked={dataInfoPanel.info?.xloc_update_audio === 1 ? true : false} style={{width: '40px', height: '20px'}}
                                                        onChange={(e) => changeSwitch(e, 'xloc_update_audio')}/>
                                                    <span style={{margin: '0px 10px'}} className="form-check-label">Update target audio</span>
                                                    {dataInfoPanel.info?.xloc_update_audio === 1 &&
                                                        <div style={{display: 'flex', gap: '4px', alignItems: 'center', flex: '1'}}>
                                                            <span className="form-check-label">Select filetype:</span>
                                                            <select 
                                                                id='filetypes'
                                                                className='form-select form-select-sm h-100'
                                                                value={dataInfoPanel.info?.xloc_update_audio_filetype_id} 
                                                                onChange={(e) => changeSwitch(e, 'xloc_update_audio_filetype_id')}
                                                                style={{flex: '1', margin: '1px 1px 0 0', padding: '0 8px'}}
                                                            >
                                                                <option key={0} value={0}>{'(No selection)'}</option>
                                                                {Object.keys(dataInfoPanel.info?.filetypes ?? {}).map(k => 
                                                                    <option key={k} value={k}>{dataInfoPanel.info.filetypes[k]}</option>
                                                                )}
                                                            </select> 
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </Fragment>
                                    }
                                </div>
                            </Protected>
                            <div>
                                <div style={{padding: '8px 0 0 10px'}}>
                                    <div style={{position: 'relative', maxHeight: '300px', overflow: 'auto', border: '1px solid #ccc', borderRadius: '6px', padding: '0 8px'}}>
                                    <table style={{width: '100%'}}>
                                        <thead style={{whiteSpace: 'nowrap', fontSize: '0.9em'}}>
                                            <tr>
                                                <th style={{fontWeight: '500'}}>Language</th>
                                                <th style={{fontWeight: '500'}}>Start Date</th>
                                                <th style={{fontWeight: '500'}}>End Date</th>
                                                <th className='th-header-button' style={{fontWeight: '500'}} 
                                                    onClick={toggleAll} title={`Activate/deactivate TC Loose adaptation.\nClick me to toggle all languages at once`}>
                                                        <span>Adapt TC%</span>
                                                        <i className=' bi bi-question-circle' style={{color: '#0065ad', marginLeft: '6px'}}/>
                                                </th>
                                                <Protected returnNull={true} permissions={['deleteNode']}>
                                                    <th style={{fontWeight: '500', paddingLeft: '34px'}}>Delete</th>
                                                </Protected>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dataInfoPanel.allScripts.map((script, index) => {
                                                return <ScriptLineDetail key={index} data={script} element={index} onUpdateLanguage={updateLanguage}
                                                        min={dataInfoPanel.info.script_start_date} 
                                                        max={dataInfoPanel.info.script_end_date} />
                                        })}
                                        </tbody>
                                    </table>
                                    </div>
                                </div>         
                            </div>
                        </fieldset>
                    </div>
                    <hr />
                    <div className="text-center" style={{display: 'flex', gap: '8px', justifyContent: 'center'}}>
                        <Protected returnNull={true} permissions={['deleteNode']} >
                            <button 
                                className="btn btn-danger btn-sm mb-3 bi bi-trash" 
                                title='Delete Script'
                                onClick={() => deactivate(0)} 
                                style={{
                                    width: '30px',
                                    height: '30px',
                                    position: 'absolute',
                                    left: '20px',
                                    padding: '2px'
                                }} 
                            />
                        </Protected>
                        <button 
                            type="submit" 
                            className="btn btn-primary btn-sm mb-3" 
                            style={{'width': '100px'}} 
                            disabled={dataInfoPanel.disabled}
                        >
                            Apply
                        </button>
                    </div>
                    <Protected returnNull={true} permissions={['deleteNode']} extraCondition={displayAlert}>
                        <div className='alert-modals'>
                            <div className='alert-modals-content-div'>
                                <div className='alert-modals-content-header'>
                                    <i className='ri-error-warning-line'/>
                                    <span >Delete Script</span>
                                    <button onClick={(e) => {
                                        e.stopPropagation();
                                        deactivate(1);
                                        setDisplayAlert(false);
                                    }}>🗙</button>
                                </div>
                                <div className='alert-modals-content-body'>
                                    {dataInfoPanel.info.active === 0 ? 
                                        <p>{`Are you sure you want to permanently delete the script ${dataInfoPanel.info.script_name}?`}</p> :
                                        <p>
                                            {`Are you sure you want to permanently delete these languages?`}
                                            {dataInfoPanel.allScripts.filter(l => l.active === 0).map(l => <span>• {l.language_code}</span>)}
                                        </p>
                                    }
                                    <div>Note: this action is not reversible</div>
                                    <label >
                                        Type "delete" to delete the script.
                                        <input 
                                            id="confirmDelete"
                                            type="text" 
                                            className="form-control form-control-sm"
                                            autoComplete="off" 
                                            spellCheck="false"
                                            onChange={(e) => setDeleteConfim(e.target.value)} 
                                            value={deleteConfim}
                                            style={{width: 'auto', height: 'fit-content'}} 
                                            autoFocus
                                        />
                                    </label>
                                </div>
                                <div className='alert-modals-content-footer'>
                                    <button 
                                        type='submit'
                                        className='btn btn-primary btn-sm mb-3' 
                                        disabled={deleteConfim !== 'delete'}
                                    >
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Protected>
                </form>
            </>
        )
    }

}

const ScriptLineDetail = (props) => {

    const start_date = useRef(null);
    const end_date = useRef(null);

    const onFocusStart = (args) => {
        start_date.show();
    }
    const onFocusEnd = (args) => {
        end_date.show();
    }

    const min = new Date(props.min).toISOString().split('T')[0]
    const max = new Date(props.max).toISOString().split('T')[0]


    return (
        <tr style={{padding: '4px', background: props.data.active === 0 ? '#ccc' : '', opacity: props.data.active === 0 ? '0.7' : '1'}}>
            <td width="80" style={{textAlign: 'center'}}>{props.data.language_code}</td>
            <td width="130">
                <DatePickerComponent width={'160px'}
                    openOnFocus={onFocusStart}
                    start={onFocusStart}
                    min={min}
                    max={max}
                    value={AM_dateTime_ExtractDate(props.data.language_start_date)}
                    change={(e) => props.onUpdateLanguage(e, 'language_start_date', props.element)}
                    format='d-MMM-yyyy' 
                    placeholder='Enter date' />
            </td>
            <td width="130">
                <DatePickerComponent width={'160px'}
                    openOnFocus={onFocusEnd}
                    start={onFocusEnd}
                    min={min}
                    max={max}
                    value={AM_dateTime_ExtractDate(props.data.language_end_date)}
                    change={(e) => props.onUpdateLanguage(e, 'language_end_date', props.element)}
                    format='d-MMM-yyyy'
                    placeholder='Enter date'/>
            </td>
            <td width="130">
                <div className="form-check form-switch">
                    <input 
                        className="form-check-input" 
                        type="checkbox" 
                        id="flexSwitchCheckChecked" 
                        checked={props.data.adapt_tc_loose === 1 ? true : false} 
                        style={{width: '40px', height: '20px', margin: 'auto'}}
                        onChange={(e) => props.onUpdateLanguage(e, 'adapt_tc_loose', props.element)}
                    /> 
                </div>
            </td>
            <Protected returnNull={true} permissions={['deleteNode']}>
                <td width="130">
                    <div className="form-check form-switch">
                        <button 
                            className={`btn btn-${props.data.active === 1 ? 'danger' : 'secondary'} btn-sm bi bi-trash`}
                            style={{width: '30px', height: '30px', padding: '2px'}}
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                props.onUpdateLanguage(props.data.active === 0 ? 1 : 0, 'active', props.element)
                            }}
                            title={`Delete ${props.data.language_code}`}
                        /> 
                    </div>
                </td>
            </Protected>
        </tr>
    )

}


function AM_dateTime_ExtractDate(string){
    // Create a Date object from the MySQL string
    const jsDate = new Date(string);

    // Array of abbreviated month names
    const abbreviatedMonths = [
    "jan", "feb", "mar", "apr", "may", "jun",
    "jul", "aug", "sep", "oct", "nov", "dec"
    ];

    // Extract day, month, and year
    const day = jsDate.getDate();
    const month = abbreviatedMonths[jsDate.getMonth()];
    const year = jsDate.getFullYear();
    // Create the formatted string
    return `${day}-${month}-${year}`;
}

function reFormatDate(dateString) {


    const date = new Date(dateString);

    const year = date.getFullYear();
    // getMonth restituisce un valore da 0 (gennaio) a 11 (dicembre), quindi aggiungi 1
    const month = date.getMonth() + 1;
    const day = date.getDate();

    // Aggiungi uno zero iniziale se il mese o il giorno sono minori di 10
    const formattedMonth = month < 10 ? `0${month}` : month;
    const formattedDay = day < 10 ? `0${day}` : day;

    return `${year}-${formattedMonth}-${formattedDay}`;
}


